import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../ui/button';

class ScreenBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromProps(props, state) {
    return props.resetKey !== state.resetKey ? { resetKey: props.resetKey, failed: false } : null;
  }
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main className="p-8 space-y-4" role="alert"><h1 className="text-2xl font-semibold">This screen could not open</h1><p className="text-muted-foreground">Reload to fetch the application files and try again.</p><Button onClick={() => window.location.reload()}>Reload application</Button></main>;
    return this.props.children;
  }
}
export function PageErrorBoundary({ children }) {
  const location = useLocation();
  return <ScreenBoundary resetKey={location.pathname}>{children}</ScreenBoundary>;
}
